import * as React from 'react';

import { Config } from '../Config.js';
import { Session } from './Session.js';

const config = new Config();
const session = new Session();

export class Mail extends React.Component {

    constructor(props) {
        super(props)
        this.leggiRisultatoMail = this.leggiRisultatoMail.bind(this);
    }
    
    inviaMail( soggetto , email , messaggio )
    {
        session.set('risulatomail' ,false);
        
        let request = new Request( config.get("utility_inviamail"),{
            method: 'POST', mode: 'cors', credentials: "include",
            body: JSON.stringify({ email:email, oggetto:soggetto, messaggio:messaggio})
        });
        
        fetch(request)
        .then(function(response){
            return response.json();
        })
        .then(function(result){
            session.set('risulatomail' ,result );
        })
    }
    
    inviaMailHome( objPostData )
    {
        session.set('risulatomail' ,false);
        
        let request = new Request( config.get("utility_inviamailHome"),{
            method: 'POST', mode: 'cors', credentials: "include",
            body: JSON.stringify(objPostData)
        });
        
        fetch(request)
        .then(function(response){
            return response.json();
        })
        .then(function(result){
            session.set('risulatomail' ,result );
        })
    }

    leggiRisultatoMail()
    {
        return session.get('risulatomail');
    }
    
}

export default Mail;


// WEBPACK FOOTER //
// ./src/AcComponents/classi/Mail.js